var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 8C9.52087 8 11.3334 6.21875 11.3334 4C11.3334 1.8125 9.52087 0 7.33337 0C5.11462 0 3.33337 1.8125 3.33337 4C3.33337 6.21875 5.11462 8 7.33337 8ZM10.1146 9H9.58337C8.89587 9.34375 8.14587 9.5 7.33337 9.5C6.52087 9.5 5.73962 9.34375 5.05212 9H4.52087C2.20837 9 0.333374 10.9062 0.333374 13.2188V14.5C0.333374 15.3438 0.989624 16 1.83337 16H12.8334C13.6459 16 14.3334 15.3438 14.3334 14.5V13.2188C14.3334 10.9062 12.4271 9 10.1146 9Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSolid);
export default __webpack_public_path__ + "static/media/user-solid.01c84be523b89cb5e49fa206f699d48c.svg";
export { ForwardRef as ReactComponent };